import React from 'react';
import { Text } from '@fluentui/react-components';
import { useFiscalEndReviewPageStyles } from '../styles/FiscalEndReviewPage.styles';
import { LastUpdatedLabel } from './LastUpdatedLabel';

interface PartnerReviewInfoBarProps {
  ttmPeriodLabel: string;
  lastUpdatedAt: string | Date | null | undefined;
}

export const PartnerReviewInfoBar: React.FC<PartnerReviewInfoBarProps> = ({ ttmPeriodLabel, lastUpdatedAt }) => {
  const styles = useFiscalEndReviewPageStyles();

  return (
    <div className={styles.ttmInfoRow}>
      <Text size={300} weight="semibold">
        TTM Revenue period: <Text size={300}>{ttmPeriodLabel}</Text>
      </Text>
      <LastUpdatedLabel at={lastUpdatedAt} />
    </div>
  );
};
